module.exports = __webpack_public_path__ + "static/img/chamber.a151c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons/chamber.png
// module id = hcD/
// module chunks = 0